<template>
  <div class="app">
    <div><head1></head1></div>
    <div class="banner">
      <div class="l-banner">
        <img src="@/assets/images/list_banner.jpg" alt="" width="100%" />
      </div>
      <div class="banner-title">
        <h1>天津津旅康养职业培训学校有限公司</h1>
        <div class="banner_title_line"></div>
      </div>
    </div>
    <div class="bread-nav">
      <span>您的位置：</span>
      <span>首页</span>
      <span class="possplit"></span>
      <span>天津津旅康养职业培训学校有限公司 </span>
    </div>
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <h1>天津津旅康养职业培训学校有限公司</h1>
          <div class="inner_content_line"></div>
          <div class="inner_content_date">
            作者：{{ form.author }} 发布日期：2022-02-18 浏览次数：422
          </div>
          <div class="inner_content_con">
            <p>天津津旅康养职业培训学校有限公司</p>
            <div class="img">
              <img src="@/assets/images/jljk1.jpg" alt="" height="450px" />
            </div>

            <div class="img">
              <img src="@/assets/images/jljk2.jpg" alt="" height="450px" />
            </div>

            <div class="bottom">
              <div class="next">上一篇：无</div>
              <div class="next">下一篇：无</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <foot></foot>
    </div>
    <div class="footer-bottom">
        <bottom></bottom>
    </div>
  </div>
</template>

<script>
import foot from "../../footer.vue";
import head1 from "../../head.vue";
import bottom from "../../bottom.vue";
export default {
  name: "App",
  components: {
    foot,
    head1,
    bottom
  },
  data() {
    return {
      images: [
        { id: 1, url: require("@/assets/images/1.png"), qq: "水电费水电费" },
        { id: 2, url: require("@/assets/images/2.png"), qq: "而威尔" },
        { id: 3, url: require("@/assets/images/4.png"), qq: "水电费是的" },
      ],
      index: "1",
      index1: "1",
      radio1: "overview",
    };
  },
  watch: {},
  created() {
    // this.index1 = this.$route.query.index1
    console.log(this.$route.query.index1, 8888);
  },

  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect1(key) {
      this.index1 = key;
    },
    jtjj() {
      this.$router.push("/147");
    },
  },
};
</script>

<style lang="scss" scoped>
.activeColor {
  color: #206bd1 !important;
}
.banner {
  position: relative;
  width: 100%;
  height: 350px;
  z-index: 99;
  .l-banner {
    height: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    text-align: center;
    margin: 0 auto;
    background-size: cover;
    width: 100%;
    overflow: hidden;;
    img {
      height: 326%;
      position: relative;
      top: -393px;
    }
  }
  .banner-title {
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -600px;
    box-sizing: border-box;
    padding-left: 41px;
    padding-top: 25px;
    width: 1200px;
    height: 110px;
    background-color: rgba(255, 255, 255, 0.8);
    h1 {
      font-size: 28px;
      color: #333;
    }
    .banner_title_line {
      width: 108px;
      height: 3px;
      margin: 3px 0;
      background-color: #88cc2f;
    }
  }
}
.bread-nav {
  width: 1200px;
  margin: 25px auto 0 auto;
  font-size: 14px;
  // color: #666;
  span {
    margin-right: 20px;
  }
  .possplit {
    position: relative;
    top: 3px;
    display: inline-block;
    margin: 0 10px;
    width: 1px;
    height: 16px;
    background-color: #acacac;
    background-image: none;
    margin-right: 20px;
  }
}
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    .el-menu {
      background-color: #fff !important;
    }
    .el-menu-item {
      width: 220px !important;
      background-color: #fff !important;
      font-size: 16px !important;
      // color: #666 !important;
      border-bottom: 1px solid #f3f3f3;
      // padding-top: 15px !important;
      // padding-bottom: 15px !important;
      // padding-left: 15px !important;
    }
    display: flex;
    width: 1200px;
    // min-width: 1200px;
    margin: 0 auto;
    .left_nav {
      margin-right: 20px;
      height: 100%;
      display: inline;
      float: left;
      width: 220px;
      background-color: #fff;
      .left_nav_title {
        box-sizing: border-box;
        padding: 23px 20px 18px 40px;
        background-color: #206bd1;
        h1 {
          font-size: 22px;
          color: #fff;
        }
        .left_nav_line {
          height: 1px;
          background-color: #fff;
          opacity: 0.2;
          margin-top: 8px;
          margin-bottom: 5px;
        }
      }
      .left_nav_list {
        cursor: pointer;
        box-sizing: border-box;
        padding: 0 10px 20px 10px;
        .left_nav_item {
          box-sizing: border-box;
          padding-top: 15px;
          padding-bottom: 15px;
          padding-left: 15px;
          border-bottom: 1px solid #f3f3f3;
        }
      }
      .select1 {
        color: #206bd1;
      }
      .li1::before {
        position: relative;
        left: -8px;
        top: 4px;
        width: 4px;
        content: "";
        background-color: #206bd1;
        height: 21px;
        display: inline-block;
      }
    }
    .inner_content_right {
      min-height: 1000px;
      padding: 61px 74px 60px 73px;
      box-sizing: border-box;
      margin-top: 30px;
      box-sizing: border-box;
      width: 1200px !important;
      background-color: #fff;
      h1 {
        font-size: 28px;
        font-weight: bold;
        color: #000000;
        line-height: 48px;
        text-align: center;
      }

      .inner_content_line {
        width: 100%;
        height: 1px;
        background: #ebebeb;
        margin: 35px 0 20px 0;
      }
      .inner_content_date {
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        color: #666666;
      }
      .inner_content_con {
        font-size: 16px;
        color: #333333;
        margin-top: 53px;
        // margin-bottom: 100px;
        p {
          font-family: 仿宋_gb2312;
          font-size: 20px;
          font-weight: 800;
          text-align: center;
          margin-bottom: 40px;
        }
        div {
          text-indent: 40px;
          font-family: 仿宋_gb2312;
          font-size: 20px;
          margin-bottom: 40px;
          //   text-align: center;
        }
        .img {
          text-align: center;
        }
        .bottom {
          margin-top: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #f3f3f3;
          .next {
            cursor: pointer;
            margin: 20px 0;
            font-size: 16px;
          }
        }
      }
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
        }
      }
      .text {
        text-indent: 45px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
.fwl {
  margin-left: 140px;
}
.jicon {
  background: url(@/assets/images/icon-ba.png) no-repeat center left;
  padding-left: 12px;
}

.footer-bottom {
  height: 50px;
  min-width: 1200px;
  background-color: #424242;
}
.footer-bottom-con {
  width: 1200px;
  height: 50px;
  margin-left: 464px;
}
.footer-bottom-con span {
  font-size: 14px;
  color: #fff;
  line-height: 50px;
  padding-right: 10px;
}
.footer-bottom-con span a {
  text-decoration: none;
  font-size: 14px;
  color: #fff;
  line-height: 50px;
  padding-right: 10px;
}
.tjlyjt {
  text-align: center;
  margin-top: 14px;
  font-size: 14px;
  color: #fff;
}
.line {
  width: 100%;
  height: 1px;
  margin: 17px 0;
  background-color: rgba(255, 255, 255, 0.3);
}
.footer-inner-right {
  margin-left: 50px;
  width: 310px;
}
.footer-inner-right-con {
  display: flex;
  margin-top: 40px;
}
.footer-inner-right-con-li {
  margin-right: 35px;
}
.footer-inner-con {
  width: 310px;
}
.footer-inner-one {
  display: flex;
  align-items: center;
}
.footer-inner-left {
  margin-right: 50px;
  width: 310px;
}
.footer-inner-left-tit {
  /* position: absolute;
  left: 0;
  top: 8px; */
  margin-right: 10px;
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  background-color: #00eb9b;
}
.footer-inner-left-title {
  font-size: 18px;
  color: #fff;
}
.footer-inner-left-title2 {
  color: #fff;
  font-size: 16px;
  margin-top: 18px;
}
.footer-inner-left-title1 a {
  color: #fff;
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
}
.footer-inner {
  display: flex;
  padding-top: 30px;
  margin-left: 462px;
}
.footer-con {
  height: 280px;
  min-width: 1200px;
  background-color: #004aba;
}
.footer-nav {
  height: 51px;
  min-width: 1200px;
  background-color: #023a8f;
  .cyqy {
    width: 850px;
  }
}
.transtion {
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
}
.fl {
  margin-right: 20px;
  width: 159px;
  height: 158px;
  background: rgba(0, 108, 255, 0.45);
  cursor: pointer;
}
.industry {
  width: 100%;
  height: 250px;
  margin-top: 36px;
  position: relative;
  padding-top: 25px;
  margin-bottom: 35px;
  background: url(@/assets/images/industry.png) no-repeat;
  background-size: 100% 100%;
}
.more {
  float: right;
  margin-top: 34px;
}
.pic-info {
  top: -60px;
  position: relative;
  z-index: 99;
  bottom: 0;
  line-height: 60px;
  background: rgba(51, 51, 51, 0.6);
  width: 96%;
  font-size: 18px;
  color: #fff;
  padding: 0 2%;
  overflow: hidden;;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mor-btn {
  /* width: 175.88px; */
  cursor: pointer;
  text-align: center;
  line-height: 36px;
  background: #f7f7f7;
  color: #919493;
  padding: 0 50px;
  /* display: inline-block; */
}
.li-content {
  display: flex;
}
.list-title {
  float: left;
  font-size: 16px;
  overflow: hidden;;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80%;
}
.list-title a {
  color: #919493;
  display: inline;
  text-decoration: none;
}
.news_list {
  width: 570px;
  height: 330px;
}
.news-title {
  line-height: 54px;
  border-bottom: 1px solid #ccc;
  font-size: 16px;
  color: #919493;
}
.left {
  width: 600px;
}
.right {
  margin-left: 30px;
}
.select:hover {
  background: url(@/assets/images/select.png) no-repeat;
  padding-bottom: 10px;
  color: #fff;
}
.li-radio {
  display: flex;
  justify-content: center;
  height: 45px;
  margin-bottom: 25px;
}
.li-radio li {
  text-align: center;
  display: inline-block;
  background: #f1f1f9;
  margin: 0 6px;
  font-size: 20px;
  width: 177px;
  line-height: 40px;
  height: 40px;
}
.title {
  margin-bottom: 50px;
}
.a-title {
  color: #970f11;
  text-decoration: none;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
::v-deep .el-carousel__indicators {
  z-index: 0 !important;
}
.logo-content {
  margin: 20px 0 20px 0;
  display: flex;
  justify-content: space-around;

  text-align: center;
}
</style>
